/* Landing Etnalia (/pages/etnalia-oferta): compra, barra fija, comparativa, reseñas y vídeos.
   Lo cargan todas las secciones etn-* (snippet etn-assets); el guard evita que corra dos veces. */
(function(){
  if(window.__etnLanding)return;window.__etnLanding=true;
  var mobile=window.matchMedia('(max-width:749px)');

  function onReady(fn){if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fn);else fn();}

  /* —— Comprar ahora: Etnalia + regalo al carrito y directo al checkout ——
     La configuración la pinta la sección etn-oferta (<script data-etn-offer>). Sin ella, el
     botón sigue su href (ancla a la oferta o ficha del producto). */
  function offerConfig(){
    var el=document.querySelector('script[data-etn-offer]');
    if(!el)return null;
    try{return JSON.parse(el.textContent)}catch(e){return null}
  }
  function showError(btn,msg){
    /* el aviso sale en la caja más cercana; si el botón no tiene (barra fija, comparativa), en la de la oferta */
    var box=(btn.parentNode&&btn.parentNode.querySelector('[data-etn-buy-error]'))||document.querySelector('[data-etn-buy-error]');
    if(box)box.textContent=msg;else if(msg)alert(msg);
  }
  function buy(btn,cfg){
    var label=btn.innerHTML;
    btn.setAttribute('aria-busy','true');if(cfg.labels&&cfg.labels.busy)btn.textContent=cfg.labels.busy;
    showError(btn,'');
    /* si /cart.js falla, se añade igualmente (sin comprobar duplicados): nunca bloquear la compra */
    fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.ok?r.json():{items:[]}},function(){return {items:[]}})
      .catch(function(){return {items:[]}})
      .then(function(cart){
        var has=function(id){return (cart.items||[]).some(function(it){return it.variant_id===id})};
        var items=[];
        /* el regalo primero y el difusor después: Shopify lista arriba lo último añadido */
        if(cfg.gift&&cfg.gift.id&&!has(cfg.gift.id))items.push({id:cfg.gift.id,quantity:1,properties:{'_gift':cfg.gift.label}});
        if(cfg.product&&cfg.product.id&&!has(cfg.product.id))items.push({id:cfg.product.id,quantity:1});
        if(!items.length)return null;
        return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
          .then(function(r){if(!r.ok)return r.json().then(function(err){throw err});return r.json()});
      })
      .then(function(){location.href=cfg.redirect||'/checkout'})
      .catch(function(err){
        btn.removeAttribute('aria-busy');btn.innerHTML=label;
        showError(btn,(err&&err.description)||(cfg.labels&&cfg.labels.error)||'');
      });
  }
  document.addEventListener('click',function(e){
    var btn=e.target.closest&&e.target.closest('[data-etn-buy]');
    if(!btn)return;
    var cfg=offerConfig();
    if(!cfg||!cfg.product||!cfg.product.id)return;
    e.preventDefault();
    if(btn.getAttribute('aria-busy')==='true')return;
    buy(btn,cfg);
  });

  onReady(function(){
    /* —— Barra fija: tras el hero, oculta mientras se ve otro botón de compra —— */
    var sticky=document.querySelector('[data-etn-sticky]');
    var hero=document.querySelector('[data-etn-hero]');
    if(sticky&&'IntersectionObserver' in window){
      var heroVisible=!!hero,heroPassed=!hero,covering=new Set();
      var render=function(){
        /* la posición del hero se mira también al hacer scroll: un salto (ancla, cambio de producto en la
           página única) puede pasar de «hero debajo» a «hero ya pasado» sin que el observer avise */
        if(hero&&!heroVisible&&hero.getClientRects().length)heroPassed=hero.getBoundingClientRect().bottom<=0;
        /* página única: si la landing de Etnalia está oculta (otro producto elegido), la barra no sale */
        var on=heroPassed&&!heroVisible&&covering.size===0&&sticky.getClientRects().length>0&&(!hero||hero.getClientRects().length>0);
        sticky.classList.toggle('is-visible',on);
        sticky.setAttribute('aria-hidden',on?'false':'true');
        sticky.querySelectorAll('a,button').forEach(function(x){x.tabIndex=on?0:-1});
        document.body.classList.toggle('etn-sticky-on',on);
      };
      if(hero)new IntersectionObserver(function(es){es.forEach(function(en){
        heroVisible=en.isIntersecting;
        if(!en.isIntersecting&&en.boundingClientRect.top<0)heroPassed=true;
        if(en.isIntersecting&&en.boundingClientRect.top>=0)heroPassed=false;
      });render()},{threshold:0}).observe(hero);
      var hideObs=new IntersectionObserver(function(es){es.forEach(function(en){
        if(en.isIntersecting)covering.add(en.target);else covering.delete(en.target);
      });render()},{threshold:0.35});
      document.querySelectorAll('[data-etn-hide-sticky]').forEach(function(el){hideObs.observe(el)});
      /* el precio solo aparece en la barra cuando ya se ha visto la oferta */
      var price=sticky.querySelector('[data-etn-sticky-price]');
      var offer=document.querySelector('[data-etn-offer-seen]');
      if(price&&offer){
        var seen=new IntersectionObserver(function(es){es.forEach(function(en){
          if(en.isIntersecting){price.hidden=false;seen.disconnect()}
        })},{threshold:0.15});
        seen.observe(offer);
      }
      render();
      var rafOn=false;
      window.addEventListener('scroll',function(){if(rafOn)return;rafOn=true;requestAnimationFrame(function(){rafOn=false;render()})},{passive:true});
      document.addEventListener('rs:ver',function(){
        if(hero&&hero.getClientRects().length){var r=hero.getBoundingClientRect();heroVisible=r.bottom>0&&r.top<window.innerHeight;heroPassed=r.bottom<=0}
        render();
      });
    }

    /* —— Comparativa: escritorio = hover o clic por celda; móvil = toque por fila, una abierta —— */
    var cmp=document.querySelectorAll('[data-etn-cmp]');
    cmp.forEach(function(root){
      var closeAll=function(except){
        root.querySelectorAll('.is-open').forEach(function(el){
          if(el!==except){el.classList.remove('is-open');el.querySelectorAll('[aria-expanded]').forEach(function(b){b.setAttribute('aria-expanded','false')})}
        });
      };
      root.addEventListener('click',function(e){
        var b=e.target.closest('[data-etn-cmp-btn]');if(!b)return;
        /* una fila abre SIEMPRE sus dos lados (porqué + cómo), en escritorio y en móvil; una abierta a la vez */
        var row=b.closest('[data-etn-cmp-row]');
        var open=!row.classList.contains('is-open');
        closeAll(row);
        row.querySelectorAll('[data-etn-cmp-cell]').forEach(function(c){c.classList.remove('is-open')});
        row.classList.toggle('is-open',open);
        row.querySelectorAll('[data-etn-cmp-btn]').forEach(function(x){x.setAttribute('aria-expanded',open?'true':'false')});
        if(open&&mobile.matches){var r=row.getBoundingClientRect();if(r.top<70)row.scrollIntoView({behavior:'smooth',block:'start'})}
      });
    });
    /* fascinaciones que llevan a su fila de la comparativa */
    document.addEventListener('click',function(e){
      var a=e.target.closest&&e.target.closest('[data-etn-goto]');if(!a)return;
      var n=a.getAttribute('data-etn-goto');
      var root=document.querySelector('[data-etn-cmp]');if(!root)return;
      e.preventDefault();
      var row=n&&n!=='top'?root.querySelector('[data-etn-cmp-row="'+n+'"]'):null;
      var target=row||root;
      target.scrollIntoView({behavior:'smooth',block:row?'center':'start'});
      if(row){
        root.querySelectorAll('.is-open').forEach(function(el){el.classList.remove('is-open')});
        root.querySelectorAll('[aria-expanded="true"]').forEach(function(b){b.setAttribute('aria-expanded','false')});
        row.classList.add('is-open');
        row.querySelectorAll('[data-etn-cmp-cell]').forEach(function(c){c.classList.add('is-open')});
        row.querySelectorAll('[data-etn-cmp-btn]').forEach(function(x){x.setAttribute('aria-expanded','true')});
      }
    });

    /* —— Reseñas: carril con scroll-snap; flechas en escritorio, swipe nativo en móvil —— */
    document.querySelectorAll('[data-etn-rail]').forEach(function(wrap){
      var track=wrap.querySelector('[data-etn-rail-track]');if(!track)return;
      var prev=wrap.querySelector('[data-etn-rail-prev]'),next=wrap.querySelector('[data-etn-rail-next]');
      var dots=wrap.querySelectorAll('[data-etn-rail-dot]');
      var step=function(){var c=track.children[0];return c?c.getBoundingClientRect().width+parseFloat(getComputedStyle(track).columnGap||getComputedStyle(track).gap||0):track.clientWidth};
      var sync=function(){
        var max=track.scrollWidth-track.clientWidth-2;
        if(prev)prev.disabled=track.scrollLeft<=2;
        if(next)next.disabled=track.scrollLeft>=max;
        if(dots.length){var i=Math.round(track.scrollLeft/step());dots.forEach(function(d,j){d.classList.toggle('is-active',j===i)})}
      };
      if(prev)prev.addEventListener('click',function(){track.scrollBy({left:-step(),behavior:'smooth'})});
      if(next)next.addEventListener('click',function(){track.scrollBy({left:step(),behavior:'smooth'})});
      dots.forEach(function(d,j){d.addEventListener('click',function(){track.scrollTo({left:j*step(),behavior:'smooth'})})});
      track.addEventListener('scroll',function(){window.requestAnimationFrame(sync)},{passive:true});
      window.addEventListener('resize',sync);sync();
    });

    /* —— Vídeo de YouTube: fachada con póster; el iframe solo se carga al darle al play —— */
    document.addEventListener('click',function(e){
      var v=e.target.closest&&e.target.closest('[data-etn-yt]');if(!v)return;
      var id=v.getAttribute('data-etn-yt');
      var f=document.createElement('iframe');
      f.src='https://www.youtube-nocookie.com/embed/'+id+'?autoplay=1&rel=0&playsinline=1&modestbranding=1';
      f.allow='autoplay; encrypted-media; picture-in-picture; fullscreen';f.allowFullscreen=true;
      f.title=v.getAttribute('aria-label')||'';
      v.replaceWith(f);
    });

    /* —— Etiqueta «Reservado» del hero: cuenta atrás a fechas reales ——
       El servidor ya pintó estado y números (visible sin JS); aquí se corrigen al segundo.
       fin = hay fin de oferta futuro · antes = sin fin y antes de la apertura · despues = sin cuenta
       atrás · off = la oferta ya acabó (se oculta). Revisión: ?etn_preview=fin|antes|despues */
    document.querySelectorAll('[data-etn-tag]').forEach(function(tag){
      var open=parseInt(tag.getAttribute('data-open'),10)||0,end=parseInt(tag.getAttribute('data-end'),10)||0;
      var pv=(location.search.match(/[?&]etn_preview=(fin|antes|despues)/)||[])[1],now0=Date.now()/1000;
      if(pv==='fin'){end=end>now0?end:Math.floor(now0+2*86400+14*3600+32*60)}
      else if(pv==='antes'){end=0;open=open>now0?open:Math.floor(now0+3*86400+5*3600)}
      else if(pv==='despues'){end=0;open=Math.floor(now0-60)}
      var q=function(sel){return tag.querySelector(sel)};
      var d=q('[data-etn-tag-d]'),h=q('[data-etn-tag-h]'),m=q('[data-etn-tag-m]'),sec=q('[data-etn-tag-s]'),timer=q('[data-etn-tag-timer]');
      var pad=function(n){return (n<10?'0':'')+n},last='';
      var tick=function(){
        var now=Date.now()/1000,state,target=0;
        if(end>0){if(end>now){state='fin';target=end}else state='off'}
        else if(open>now){state='antes';target=open}
        else state='despues';
        if(state!==last){
          last=state;
          tag.hidden=state==='off';
          tag.setAttribute('data-state',state);
          tag.querySelectorAll('[data-etn-tag-state]').forEach(function(el){el.hidden=el.getAttribute('data-etn-tag-state')!==state});
          if(timer)timer.hidden=!target;
        }
        if(target){
          var x=Math.max(0,Math.floor(target-now));
          if(d)d.textContent=pad(Math.floor(x/86400));
          if(h)h.textContent=pad(Math.floor(x%86400/3600));
          if(m)m.textContent=pad(Math.floor(x%3600/60));
          if(sec)sec.textContent=pad(x%60);
        }
      };
      tick();setInterval(tick,1000);
    });

    /* —— Vídeos ambientales: solo se reproducen mientras se ven —— */
    var amb=document.querySelectorAll('video[data-etn-ambient],.etn-ambient video');
    if(amb.length&&'IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(en){
        var v=en.target;
        if(en.isIntersecting){var p=v.play&&v.play();if(p&&p.catch)p.catch(function(){})}else if(v.pause)v.pause();
      })},{threshold:0.2});
      amb.forEach(function(v){v.muted=true;io.observe(v)});
    }
  });
})();
